/// <amd-module name="Build/Admin/Checks/Flux" />
import { IVssPageContext } from "VSS/Platform/Context";

import { ActionsHub } from "Build/Admin/Checks/Actions/ActionsHub";
import { ChecksActionCreator } from "Build/Admin/Checks/Actions/ChecksActionCreator";
import { StoresHub } from "Build/Admin/Checks/Stores/StoresHub";
import { AgentPoolSource } from "Build/Admin/Common/Sources/AgentPoolSource";
import { AgentQueueSource } from "Build/Admin/Common/Sources/AgentQueueSource";
import { SecuritySource } from "Build/Admin/Common/Sources/SecuritySource";

export class Flux {
    public actionsHub: ActionsHub;
    public agentPoolSource: AgentPoolSource;
    public agentQueueSource: AgentQueueSource;
    public checksActionCreator: ChecksActionCreator;
    public securitySource: SecuritySource;
    public storesHub: StoresHub;

    public constructor(pageContext: IVssPageContext) {
        this.actionsHub = new ActionsHub();
        this.agentPoolSource = new AgentPoolSource(pageContext);
        this.agentQueueSource = new AgentQueueSource(pageContext);
        this.securitySource = new SecuritySource(pageContext);
        this.storesHub = new StoresHub(this.actionsHub);
        this.checksActionCreator = new ChecksActionCreator({
            pageContext: pageContext,
            actionsHub: this.actionsHub,
            agentPoolSource: this.agentPoolSource,
            agentQueueSource: this.agentQueueSource,
            securitySource: this.securitySource,
            storesHub: this.storesHub
        });
    }
}
